var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"1000px"},attrs:{"name":"child","id":"child","src":_vm.reportUrl,"width":"auto","height":"300","frameborder":"0","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }